// Simplified Featured Collection Filter
(function() {
  console.log("Simplified Featured Collection Filter loaded");
  
  // Run on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    console.log("Initializing featured collection filters");
    
    // Find all sections that need filtering
    const sections = document.querySelectorAll('.best-sellers-section, .featured-collection');
    console.log(`Found ${sections.length} collection sections to initialize`);
    
    sections.forEach(section => {
      // Find tabs within this section
      const tabs = section.querySelectorAll('.product-tab');
      console.log(`Found ${tabs.length} tabs in section`);
      
      if (tabs.length === 0) return;
      
      // Find products within this section
      const products = section.querySelectorAll('.custom-product-item, .grid__item');
      console.log(`Found ${products.length} products in section`);
      
      if (products.length === 0) return;
      
      // Apply spacing fixes to reduce gap between heading and tabs
      const sectionHeader = section.querySelector('.section-header');
      if (sectionHeader) {
        sectionHeader.style.marginBottom = '15px'; // Reduced from 30px
      }
      
      const collectionFilters = section.querySelector('.collection-filters');
      if (collectionFilters) {
        collectionFilters.style.marginBottom = '20px'; // Reduced from 30px
      }
      
      const productTabs = section.querySelector('.product-tabs');
      if (productTabs) {
        productTabs.style.paddingBottom = '0'; // Reduced from 10px
      }
      
      // Remove any existing click handlers from tabs (to avoid duplicates)
      const newTabs = [];
      tabs.forEach(tab => {
        const newTab = tab.cloneNode(true);
        tab.parentNode.replaceChild(newTab, tab);
        newTabs.push(newTab); // Store reference to new tab
      });
      
      // Now add click handlers to the NEW tabs
      newTabs.forEach(tab => {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          
          // Update active tab visually - use newTabs array instead of original tabs
          newTabs.forEach(t => {
            t.classList.remove('active');
            t.style.borderBottom = '2px solid transparent';
          });
          
          this.classList.add('active');
          this.style.borderBottom = '2px solid #7B4AE2';
          
          // Get filter value
          const filter = this.getAttribute('href').replace('#', '').toLowerCase();
          console.log(`Tab clicked: ${this.textContent.trim()}`);
          console.log(`Filtering by: ${filter}`);
          
          // Filter products
          if (filter === 'all') {
            // Show all products
            products.forEach(product => {
              product.style.display = '';
            });
          } else {
            // Filter by category
            products.forEach(product => {
              const productType = (product.getAttribute('data-product-type') || '').toLowerCase();
              const productTags = (product.getAttribute('data-product-tags') || '').toLowerCase();
              const productTitle = product.querySelector('.custom-product-title')?.textContent.toLowerCase() || '';
              
              // Check if product matches filter
              if (
                productType === filter || 
                productTags.includes(filter) || 
                (filter === 't-shirts' && (productTitle.includes('tee') || productTitle.includes('t-shirt'))) ||
                (filter === 'hoodies' && productTitle.includes('hoodie')) ||
                (filter === 'hats' && (productTitle.includes('hat') || productTitle.includes('cap')))
              ) {
                product.style.display = '';
              } else {
                product.style.display = 'none';
              }
            });
          }
        });
      });
      
      // Activate the first tab by default or use URL hash if present
      const hash = window.location.hash.replace('#', '').toLowerCase();
      if (hash) {
        const matchingTab = newTabs.find(tab => {
          return tab.getAttribute('href').replace('#', '').toLowerCase() === hash;
        });
        
        if (matchingTab) {
          matchingTab.click();
        } else {
          newTabs[0].click();
        }
      } else {
        newTabs[0].click();
      }
    });
  });
})();